export enum BtnTypeEnum {
    "DISABLED",
    "DEPOSITE",
    "CANCLAIM",
    "CLAIMED",
}

export const BtnTypeMap = new Map<BtnTypeEnum, string>([
    [BtnTypeEnum.DISABLED, "Recompensa Recebida"],
    [BtnTypeEnum.DEPOSITE, "Recarregar"],
    [BtnTypeEnum.CANCLAIM, "Receber Recompensa"],
]);

// 进行中running、待领取pending、已领取received、已过期expired

export enum CashbackStatusEnum {
    "RUNNING" = "running",
    "PENDING" = "pending",
    "RECEIVED" = "received",
    "EXPIRED" = "expired",
}

export const CashbackStatusMap = new Map<CashbackStatusEnum, string>([
    [CashbackStatusEnum.RUNNING, "cashback.goGame"],
    [CashbackStatusEnum.PENDING, "cashback.receiveButton"],
    [CashbackStatusEnum.RECEIVED, "cashback.goGame"],
    [CashbackStatusEnum.EXPIRED, "cashback.goGame"],
]);

export const ClaimActiveErrorMap = new Map<number, string>([
    [1022, "Restrição anormal de conta"],
    [6002, "Nenhum bônus não pode ser reclamado no modo bônus ativado"],
    [6001, "As condições do bônus de esvaziamento não são atendidas"],
]);
